import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-ce12237e"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "schedule-page-root"
};
const _hoisted_2 = {
  class: "main-scroll-bottombar-content"
};
const _hoisted_3 = {
  class: "schedule-17"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "schedule-top-banner-img",
  src: "https://summit-img.geekpark.net/if2023/schedule_17_top_banner_10.png",
  alt: "12月17号日程头图"
}, null, -1));

const _hoisted_5 = {
  key: 0,
  class: "speechs-box"
};

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "guest-share-title"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "Remarks 系列分享:"), /*#__PURE__*/_createElementVNode("div", {
  class: "desc"
}, [/*#__PURE__*/_createElementVNode("span", null, "呈现更丰富、更多元视角的技术思考、"), /*#__PURE__*/_createElementVNode("span", null, "产业洞察、实践 Know-how")])], -1));

const _hoisted_7 = {
  key: 0,
  class: "main-top-part"
};

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "left-part"
}, null, -1));

const _hoisted_9 = {
  class: "right-part"
};
const _hoisted_10 = {
  class: "speech-title"
};

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "header-title-box"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "header-title speaker-company-header"
}, "SPEAKER & COMPANY."), /*#__PURE__*/_createElementVNode("span", {
  class: "header-title title-header"
}, "TITLE.")], -1));

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "header-title time-header"
}, "TIME.", -1));

const _hoisted_13 = {
  class: "main-bottom-part"
};
const _hoisted_14 = {
  class: "guests-box"
};
const _hoisted_15 = {
  key: 0,
  class: "guests-item guests-item-single"
};
const _hoisted_16 = {
  class: "guest-avatar-img-box"
};
const _hoisted_17 = {
  class: "guest-avatar-img-border"
};
const _hoisted_18 = ["src", "alt"];
const _hoisted_19 = {
  class: "guest-info-box"
};
const _hoisted_20 = {
  class: "guest-name"
};
const _hoisted_21 = {
  class: "line-2"
};
const _hoisted_22 = {
  class: "guest-company"
};
const _hoisted_23 = {
  class: "guest-title"
};
const _hoisted_24 = {
  class: "guest-avatar-img-box"
};
const _hoisted_25 = {
  class: "guest-avatar-img-border"
};
const _hoisted_26 = ["src", "alt"];
const _hoisted_27 = {
  class: "guest-info-box"
};
const _hoisted_28 = {
  class: "guest-name"
};
const _hoisted_29 = {
  class: "line-2"
};
const _hoisted_30 = {
  class: "guest-company"
};
const _hoisted_31 = {
  class: "guest-title"
};
const _hoisted_32 = {
  class: "speech-start-at"
};

const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "to-icon"
}, "TO", -1));

const _hoisted_34 = {
  class: "speech-end-at"
};

const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tags-left-part"
}, null, -1));

const _hoisted_36 = {
  class: "tags-content"
};

const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tags-right-part"
}, null, -1));

const _hoisted_38 = {
  class: "schedule-18"
};

const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "schedule-top-banner-img",
  src: "https://summit-img.geekpark.net/if2023/schedule_18_top_banner_10.png",
  alt: "12月18号日程头图"
}, null, -1));

const _hoisted_40 = {
  key: 0,
  class: "speechs-box"
};

const _hoisted_41 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "guest-share-title"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "Cool Kids 系列分享:"), /*#__PURE__*/_createElementVNode("div", {
  class: "desc"
}, "展现科技创新的新人、新故事、新发现、新画面")], -1));

const _hoisted_42 = {
  key: 0,
  class: "main-top-part"
};

const _hoisted_43 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "left-part"
}, null, -1));

const _hoisted_44 = {
  class: "right-part"
};
const _hoisted_45 = {
  class: "speech-title"
};

const _hoisted_46 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "header-title-box"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "header-title speaker-company-header"
}, "SPEAKER & COMPANY."), /*#__PURE__*/_createElementVNode("span", {
  class: "header-title title-header"
}, "TITLE.")], -1));

const _hoisted_47 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "header-title time-header"
}, "TIME.", -1));

const _hoisted_48 = {
  class: "main-bottom-part"
};
const _hoisted_49 = {
  class: "guests-box"
};
const _hoisted_50 = {
  key: 0,
  class: "guests-item guests-item-single"
};
const _hoisted_51 = {
  class: "guest-avatar-img-box"
};
const _hoisted_52 = {
  class: "guest-avatar-img-border"
};
const _hoisted_53 = ["src", "alt"];
const _hoisted_54 = {
  class: "guest-info-box"
};
const _hoisted_55 = {
  class: "guest-name"
};
const _hoisted_56 = {
  class: "line-2"
};
const _hoisted_57 = {
  class: "guest-company"
};
const _hoisted_58 = {
  class: "guest-title"
};
const _hoisted_59 = {
  class: "guest-avatar-img-box"
};
const _hoisted_60 = {
  class: "guest-avatar-img-border"
};
const _hoisted_61 = ["src", "alt"];
const _hoisted_62 = {
  class: "guest-info-box"
};
const _hoisted_63 = {
  class: "guest-name"
};
const _hoisted_64 = {
  class: "line-2"
};
const _hoisted_65 = {
  class: "guest-company"
};
const _hoisted_66 = {
  class: "guest-title"
};
const _hoisted_67 = {
  class: "speech-start-at"
};

const _hoisted_68 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "to-icon"
}, "TO", -1));

const _hoisted_69 = {
  class: "speech-end-at"
};

const _hoisted_70 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tags-left-part"
}, null, -1));

const _hoisted_71 = {
  class: "tags-content"
};

const _hoisted_72 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tags-right-part"
}, null, -1));

const _hoisted_73 = {
  class: "fixed-share-btn-box"
};

const _hoisted_74 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "fixed-share-btn",
  src: "https://summit-img.geekpark.net/if2023/share_schedule_btn_1.png",
  alt: "分享日程按钮"
}, null, -1));

import { onBeforeMount, ref } from "vue";
import { eventApiHost, activityId } from "../common.config";
import request from "../assets/utils/request";
import dayjs from "dayjs";
import { Toast } from "vant";
import Footer from "../components/Footer.vue";
import ShareBtn from "../components/ShareBtn.vue";
export default {
  __name: 'Schedule',
  props: {},

  setup(__props) {
    const props = __props;
    const tabActive = ref(0);
    onBeforeMount(() => {
      fetchSchedule();
      shareRemind();
    });
    const schedule17 = ref([]);
    const schedule18 = ref([]);

    const fetchSchedule = () => {
      Toast.loading({
        message: "加载中...",
        forbidClick: true
      });
      request(`${eventApiHost}/api/v1/activities/${activityId}`).then(res => {
        const viceActivities = res === null || res === void 0 ? void 0 : res.vice_activities;

        if (viceActivities && viceActivities.length) {
          const dates = [17, 18];
          viceActivities.forEach((item, index) => {
            if (dayjs(item.info.end_at).format("DD") == dates[0]) {
              schedule17.value = item.speeches[0]["speeches"];
            } else if (dayjs(item.info.end_at).format("DD") == dates[1]) {
              schedule18.value = item.speeches[0]["speeches"];
            } else {}
          }); // 格式化开始-结束时间

          schedule17.value.forEach(item => {
            if (item.start_at && item.end_at) {
              if (dayjs(item.start_at).format("YYYY-MM-DD HH:mm:ss") === "2022-02-02 00:00:00" || dayjs(item.end_at).format("YYYY-MM-DD HH:mm:ss") === "2022-02-02 00:00:00") {
                item.startAtStr = "";
                item.endAtStr = "";
              } else {
                item.startAtStr = item.start_at && dayjs(item.start_at).format("HH:mm");
                item.endAtStr = item.end_at && dayjs(item.end_at).format("HH:mm");
              }
            } else {
              item.startAtStr = "";
              item.endAtStr = "";
            }

            const preTags = item.description && item.description.replace(/[,，]+/g, ",").split(/[,，]/);
            item.tags = preTags && preTags.filter(tag => {
              return !!tag;
            });
            item.guests && item.guests.forEach(guest => {
              guest.companyArr = guest.company.split("/");
            });
            item.guests && item.guests.forEach(guest => {
              guest.titleArr = guest.title.split("/");
            });
          });
          schedule18.value.forEach(item => {
            if (item.start_at && item.end_at) {
              if (dayjs(item.start_at).format("YYYY-MM-DD HH:mm:ss") === "2022-02-02 00:00:00" || dayjs(item.end_at).format("YYYY-MM-DD HH:mm:ss") === "2022-02-02 00:00:00") {
                item.startAtStr = "";
                item.endAtStr = "";
              } else {
                item.startAtStr = item.start_at && dayjs(item.start_at).format("HH:mm");
                item.endAtStr = item.end_at && dayjs(item.end_at).format("HH:mm");
              }
            } else {
              item.startAtStr = "";
              item.endAtStr = "";
            }

            const preTags = item.description && item.description.replace(/[,，]+/g, ",").split(/[,，]/);
            item.tags = preTags && preTags.filter(tag => {
              return !!tag;
            });
            item.guests && item.guests.forEach(guest => {
              guest.companyArr = guest.company.split("/");
            });
            item.guests && item.guests.forEach(guest => {
              guest.titleArr = guest.title.split("/");
            });
          });
        }

        Toast.clear();
      }).catch(err => {
        Toast.clear();
        console.error("fetchSchedule: ", err);
      });
    }; // 处理分享的内容


    const shareMessage = ref("");
    const wxShareMessage = ref("");

    const shareRemind = () => {
      const href = "IF 2023 大咖嘉宾都在这里了！打开链接立即查看" + "https://if.geekpark.net/";
      shareMessage.value = href;
      wxShareMessage.value = "点击页面右上角「···」\n分享日程给好友吧~";
    };

    return (_ctx, _cache) => {
      const _component_van_empty = _resolveComponent("van-empty");

      const _component_van_tab = _resolveComponent("van-tab");

      const _component_van_tabs = _resolveComponent("van-tabs");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_van_tabs, {
        active: tabActive.value,
        "onUpdate:active": _cache[0] || (_cache[0] = $event => tabActive.value = $event),
        type: "card",
        swipeable: "",
        sticky: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_van_tab, {
          title: "12月17号"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_hoisted_4, schedule17.value && schedule17.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_hoisted_6, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(schedule17.value, speech => {
            var _speech$guests$, _speech$guests$$avato, _speech$guests$2, _speech$guests$3, _speech$guests$4, _speech$guests$5;

            return _openBlock(), _createElementBlock("div", {
              class: "speechs-item",
              key: speech.title
            }, [speech.title && speech.title !== '暂无' ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_hoisted_8, _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString(speech.title), 1), _hoisted_11, _hoisted_12])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [speech.guests.length === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("img", {
              class: "guest-avatar-img",
              src: speech === null || speech === void 0 ? void 0 : (_speech$guests$ = speech.guests[0]) === null || _speech$guests$ === void 0 ? void 0 : (_speech$guests$$avato = _speech$guests$.avator) === null || _speech$guests$$avato === void 0 ? void 0 : _speech$guests$$avato.url,
              alt: (_speech$guests$2 = speech.guests[0]) === null || _speech$guests$2 === void 0 ? void 0 : _speech$guests$2.name
            }, null, 8, _hoisted_18)])]), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, _toDisplayString((_speech$guests$3 = speech.guests[0]) === null || _speech$guests$3 === void 0 ? void 0 : _speech$guests$3.name), 1), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_speech$guests$4 = speech.guests[0]) === null || _speech$guests$4 === void 0 ? void 0 : _speech$guests$4.companyArr, companyItem => {
              return _openBlock(), _createElementBlock("div", {
                key: companyItem,
                class: "company-item"
              }, _toDisplayString(companyItem), 1);
            }), 128))]), _createElementVNode("div", _hoisted_23, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_speech$guests$5 = speech.guests[0]) === null || _speech$guests$5 === void 0 ? void 0 : _speech$guests$5.titleArr, titleItem => {
              return _openBlock(), _createElementBlock("div", {
                key: titleItem,
                class: "guest-title-item"
              }, _toDisplayString(titleItem), 1);
            }), 128))])])])])) : (_openBlock(true), _createElementBlock(_Fragment, {
              key: 1
            }, _renderList(speech === null || speech === void 0 ? void 0 : speech.guests, guest => {
              return _openBlock(), _createElementBlock("div", {
                class: "guests-item guests-item-muti",
                key: guest.id
              }, [_createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createElementVNode("img", {
                class: "guest-avatar-img",
                src: guest.avator.url,
                alt: guest.name
              }, null, 8, _hoisted_26)])]), _createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, _toDisplayString(guest.name), 1), _createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(guest === null || guest === void 0 ? void 0 : guest.companyArr, companyItem => {
                return _openBlock(), _createElementBlock("div", {
                  key: companyItem,
                  class: "company-item"
                }, _toDisplayString(companyItem), 1);
              }), 128))]), _createElementVNode("div", _hoisted_31, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(guest === null || guest === void 0 ? void 0 : guest.titleArr, titleItem => {
                return _openBlock(), _createElementBlock("div", {
                  key: titleItem,
                  class: "guest-title-item"
                }, _toDisplayString(titleItem), 1);
              }), 128))])])])]);
            }), 128))]), _createElementVNode("div", {
              class: _normalizeClass(['speech-time', speech.startAtStr && speech.endAtStr ? '' : 'no-speech-time'])
            }, [_createElementVNode("div", _hoisted_32, _toDisplayString(speech.startAtStr), 1), _hoisted_33, _createElementVNode("div", _hoisted_34, _toDisplayString(speech.endAtStr), 1)], 2)]), speech.tags && speech.tags.length > 0 ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(['tags-box', speech.guests.length === 1 ? '' : 'up-line'])
            }, [_hoisted_35, _createElementVNode("div", _hoisted_36, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(speech.tags, tag => {
              return _openBlock(), _createElementBlock("span", {
                key: tag,
                class: "tag-item"
              }, " #" + _toDisplayString(tag) + "# ", 1);
            }), 128))]), _hoisted_37], 2)) : _createCommentVNode("", true), _createElementVNode("div", {
              class: _normalizeClass(['color-bar', 'color-bar-16', speech.guests.length > 1 ? 'margin-top-1' : ''])
            }, null, 2)]);
          }), 128))])) : (_openBlock(), _createBlock(_component_van_empty, {
            key: 1,
            description: "即将揭晓，敬请期待~"
          })), schedule17.value && schedule17.value.length > 0 ? (_openBlock(), _createBlock(Footer, {
            key: 2
          })) : _createCommentVNode("", true)])]),
          _: 1
        }), _createVNode(_component_van_tab, {
          title: "12月18号"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_38, [_hoisted_39, schedule18.value && schedule18.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_40, [_hoisted_41, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(schedule18.value, speech => {
            var _speech$guests$6, _speech$guests$6$avat, _speech$guests$7, _speech$guests$8, _speech$guests$9, _speech$guests$10;

            return _openBlock(), _createElementBlock("div", {
              class: "speechs-item",
              key: speech.title
            }, [speech.title && speech.title !== '暂无' ? (_openBlock(), _createElementBlock("div", _hoisted_42, [_hoisted_43, _createElementVNode("div", _hoisted_44, [_createElementVNode("div", _hoisted_45, _toDisplayString(speech.title), 1), _hoisted_46, _hoisted_47])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_48, [_createElementVNode("div", _hoisted_49, [speech.guests.length === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_50, [_createElementVNode("div", _hoisted_51, [_createElementVNode("div", _hoisted_52, [_createElementVNode("img", {
              class: "guest-avatar-img",
              src: speech === null || speech === void 0 ? void 0 : (_speech$guests$6 = speech.guests[0]) === null || _speech$guests$6 === void 0 ? void 0 : (_speech$guests$6$avat = _speech$guests$6.avator) === null || _speech$guests$6$avat === void 0 ? void 0 : _speech$guests$6$avat.url,
              alt: (_speech$guests$7 = speech.guests[0]) === null || _speech$guests$7 === void 0 ? void 0 : _speech$guests$7.name
            }, null, 8, _hoisted_53)])]), _createElementVNode("div", _hoisted_54, [_createElementVNode("div", _hoisted_55, _toDisplayString((_speech$guests$8 = speech.guests[0]) === null || _speech$guests$8 === void 0 ? void 0 : _speech$guests$8.name), 1), _createElementVNode("div", _hoisted_56, [_createElementVNode("div", _hoisted_57, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_speech$guests$9 = speech.guests[0]) === null || _speech$guests$9 === void 0 ? void 0 : _speech$guests$9.companyArr, companyItem => {
              return _openBlock(), _createElementBlock("div", {
                key: companyItem,
                class: "company-item"
              }, _toDisplayString(companyItem), 1);
            }), 128))]), _createElementVNode("div", _hoisted_58, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_speech$guests$10 = speech.guests[0]) === null || _speech$guests$10 === void 0 ? void 0 : _speech$guests$10.titleArr, titleItem => {
              return _openBlock(), _createElementBlock("div", {
                key: titleItem,
                class: "guest-title-item"
              }, _toDisplayString(titleItem), 1);
            }), 128))])])])])) : (_openBlock(true), _createElementBlock(_Fragment, {
              key: 1
            }, _renderList(speech === null || speech === void 0 ? void 0 : speech.guests, guest => {
              return _openBlock(), _createElementBlock("div", {
                class: _normalizeClass(['guests-item', 'guests-item-muti', speech.guests.length === 2 ? 'guests-item-muti-last-2' : '', speech.guests.length > 2 && speech.guests.length % 2 === 0 ? 'guests-item-muti-last-2' : '', speech.guests.length > 2 && speech.guests.length % 2 === 1 ? 'guests-item-muti-last-1' : '']),
                key: guest.id
              }, [_createElementVNode("div", _hoisted_59, [_createElementVNode("div", _hoisted_60, [_createElementVNode("img", {
                class: "guest-avatar-img",
                src: guest.avator.url,
                alt: guest.name
              }, null, 8, _hoisted_61)])]), _createElementVNode("div", _hoisted_62, [_createElementVNode("div", _hoisted_63, _toDisplayString(guest.name), 1), _createElementVNode("div", _hoisted_64, [_createElementVNode("div", _hoisted_65, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(guest === null || guest === void 0 ? void 0 : guest.companyArr, companyItem => {
                return _openBlock(), _createElementBlock("div", {
                  key: companyItem,
                  class: "company-item"
                }, _toDisplayString(companyItem), 1);
              }), 128))]), _createElementVNode("div", _hoisted_66, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(guest === null || guest === void 0 ? void 0 : guest.titleArr, titleItem => {
                return _openBlock(), _createElementBlock("div", {
                  key: titleItem,
                  class: "guest-title-item"
                }, _toDisplayString(titleItem), 1);
              }), 128))])])])], 2);
            }), 128))]), _createElementVNode("div", {
              class: _normalizeClass(['speech-time', speech.startAtStr && speech.endAtStr ? '' : 'no-speech-time'])
            }, [_createElementVNode("div", _hoisted_67, _toDisplayString(speech.startAtStr), 1), _hoisted_68, _createElementVNode("div", _hoisted_69, _toDisplayString(speech.endAtStr), 1)], 2)]), speech.tags && speech.tags.length > 0 ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(['tags-box', speech.guests.length === 1 ? '' : 'up-line'])
            }, [_hoisted_70, _createElementVNode("div", _hoisted_71, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(speech.tags, tag => {
              return _openBlock(), _createElementBlock("span", {
                key: tag,
                class: "tag-item"
              }, " #" + _toDisplayString(tag) + "# ", 1);
            }), 128))]), _hoisted_72], 2)) : _createCommentVNode("", true), _createElementVNode("div", {
              class: _normalizeClass(['color-bar', 'color-bar-18', speech.guests.length > 1 ? 'margin-top-1' : ''])
            }, null, 2)]);
          }), 128))])) : (_openBlock(), _createBlock(_component_van_empty, {
            key: 1,
            description: "即将揭晓，敬请期待~"
          })), schedule18.value && schedule18.value.length > 0 ? (_openBlock(), _createBlock(Footer, {
            key: 2
          })) : _createCommentVNode("", true)])]),
          _: 1
        })]),
        _: 1
      }, 8, ["active"]), _createElementVNode("div", _hoisted_73, [_createVNode(ShareBtn, {
        id: "ga4-guest-share",
        message: shareMessage.value,
        wxShareMessage: wxShareMessage.value
      }, {
        default: _withCtx(() => [_hoisted_74]),
        _: 1
      }, 8, ["message", "wxShareMessage"])])])]);
    };
  }

};